import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  QueryList,
  TemplateRef,
  ViewChildren,
} from '@angular/core';
import {
  AssetUnitPipe,
  ChainRepository,
  BLOCK_EXPLORER_TOKEN_LINK,
  BLOCK_EXPLORER_TX_LINK,
  LoadingSpinnerComponent,
  TokenLogoComponent,
  TradeSateEnum,
  Trade,
  PricePipe,
} from 'common';
import { Rebalancing } from '../../model';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import {
  heroArrowLongRightMini,
  heroCheckCircleMini,
  heroExclamationTriangleMini,
  heroXCircleMini,
} from '@ng-icons/heroicons/mini';
import { NgxFloatUiModule } from 'ngx-float-ui';
import { TradeFillsComponent } from './trade-fills';
import { TradeSankeyComponent } from './trades-sankey';
import { RebalancingStep } from '../rebalancing';
import { RebalancingRepository, RebalancingState } from '../../repository';

@Component({
  selector: 'common-rebalancing-order-details-trades',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    TokenLogoComponent,
    AssetUnitPipe,
    LoadingSpinnerComponent,
    NgxFloatUiModule,
    NgIconComponent,
    TradeFillsComponent,
    TradeSankeyComponent,
    PricePipe,
  ],
  providers: [
    provideIcons({
      heroArrowLongRightMini,
      heroCheckCircleMini,
      heroExclamationTriangleMini,
      heroXCircleMini,
    }),
  ],
  templateUrl: './trades.component.html',
  styleUrls: ['./trades.component.scss'],
})
export class TradesComponent implements AfterViewInit {
  public BLOCK_EXPLORER_TX_LINK = BLOCK_EXPLORER_TX_LINK;
  public BLOCK_EXPLORER_TOKEN_LINK = BLOCK_EXPLORER_TOKEN_LINK;

  public rebalancingSteps = RebalancingStep;
  public tradeStates = TradeSateEnum;

  @ViewChildren('fromAmount')
  public fromAmounts: QueryList<ElementRef>;
  public fromAmountWidth: number;

  @ViewChildren('fromToken')
  public fromTokens: QueryList<ElementRef>;
  public fromTokenWidth: number;

  @ViewChildren('fromValue')
  public fromValues: QueryList<ElementRef>;
  public fromValueWidth: number;

  @ViewChildren('toAmount')
  public toAmounts: QueryList<ElementRef>;
  public toAmountWidth: number;

  @ViewChildren('toToken')
  public toTokens: QueryList<ElementRef>;
  public toTokenWidth: number;

  @ViewChildren('toValue')
  public toValues: QueryList<ElementRef>;
  public toValueWidth: number;

  @Input()
  public trades: Trade[] | undefined;

  @Input()
  public rebalancing: Rebalancing | undefined;

  @Input()
  public customStatusIcons: TemplateRef<any>;

  constructor(
    public chainRepository: ChainRepository,
    public rebalancingRepository: RebalancingRepository,
  ) {}

  public get rebalancingStore(): RebalancingState {
    return this.rebalancingRepository.store.getValue();
  }

  public ngAfterViewInit(): void {
    this.calculateFromAmountWidth();
    this.calculateFromTokenWidth();
    this.calculateFromValueWidth();
    this.calculateToAmountWidth();
    this.calculateToTokenWidth();
    this.calculateToValueWidth();
  }

  private calculateFromAmountWidth(): void {
    this.fromAmountWidth = this.calculateMaxWidth(this.fromAmounts);
  }

  private calculateFromTokenWidth(): void {
    this.fromTokenWidth = this.calculateMaxWidth(this.fromTokens);
  }

  private calculateFromValueWidth(): void {
    this.fromValueWidth = this.calculateMaxWidth(this.fromValues);
  }

  private calculateToAmountWidth(): void {
    this.toAmountWidth = this.calculateMaxWidth(this.toAmounts);
  }

  private calculateToTokenWidth(): void {
    this.toTokenWidth = this.calculateMaxWidth(this.toTokens);
  }

  private calculateToValueWidth(): void {
    this.toValueWidth = this.calculateMaxWidth(this.toValues);
  }

  private calculateMaxWidth(elements: QueryList<ElementRef>): number {
    let maxWidth = 0;
    elements.forEach(element => {
      const width = element.nativeElement.offsetWidth;
      if (width > maxWidth) {
        maxWidth = width;
      }
    });

    return maxWidth;
  }
}
